'use client';
import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    const top = document.getElementById('top');
    if (top) {
      top?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <>
      {/* Inline back-to-top link at bottom of content */}
      <div className="flex justify-center pb-4">
        <button
          onClick={scrollToTop}
          className="flex items-center gap-2 text-sm font-semibold text-muted-foreground hover:text-primary transition-colors duration-150 group"
          aria-label="Back to top"
        >
          <ArrowUp
            size={16}
            className="group-hover:-translate-y-0.5 transition-transform duration-150"
          />
          Back to top
        </button>
      </div>

      {/* Floating back-to-top button */}
      <button
        onClick={scrollToTop}
        aria-label="Scroll back to top"
        className={`fixed bottom-6 right-6 z-50 w-11 h-11 rounded-full bg-primary text-white shadow-card-hover flex items-center justify-center transition-all duration-200 hover:bg-primary/90 active:scale-95 ${
          visible
            ? 'opacity-100 translate-y-0 pointer-events-auto' :'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <ArrowUp size={18} />
      </button>
    </>
  );
}